import { configureStore, combineReducers } from "@reduxjs/toolkit"
import rentReducer from "../features/rentSlice"
import calendarReducer from "../features/calendarSlice"
import formReducer from "../features/formSlice"
import authReducer from "../features/authSlice"
import workspaceReducer from "../features/workspaceSlice"
import analyticsReducer from "../features/analyticsSlice"
import errorReducer from "../features/errorSlice"

const appReducer = combineReducers({
  auth: authReducer,
  rent: rentReducer,
  calendar: calendarReducer,
  form: formReducer,
  workspace: workspaceReducer,
  analytics: analyticsReducer,
  error: errorReducer,
})

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
})
